import { Helmet } from 'react-helmet-async';
import { useLanguage } from '../../contexts/LanguageContext';

const SEOHead = ({ 
  titlePT, 
  titleEN, 
  descriptionPT, 
  descriptionEN,
  canonical,
  ogImage 
}) => {
  const { language } = useLanguage();
  
  const title = language === 'pt' ? titlePT : titleEN;
  const description = language === 'pt' ? descriptionPT : descriptionEN;
  
  const baseUrl = window.location.origin;
  const currentPath = window.location.pathname;
  
  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <html lang={language} />
      <title>{title}</title>
      <meta name="description" content={description} />
      
      {/* Canonical URL */}
      <link rel="canonical" href={canonical || `${baseUrl}${currentPath}`} />
      
      {/* Alternate Language Links (hreflang) */}
      <link rel="alternate" hrefLang="pt" href={`${baseUrl}/pt${currentPath}`} />
      <link rel="alternate" hrefLang="en" href={`${baseUrl}/en${currentPath}`} />
      <link rel="alternate" hrefLang="x-default" href={`${baseUrl}${currentPath}`} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={`${baseUrl}${currentPath}`} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:locale" content={language === 'pt' ? 'pt_PT' : 'en_US'} />
      <meta property="og:locale:alternate" content={language === 'pt' ? 'en_US' : 'pt_PT'} />
      {ogImage && <meta property="og:image" content={ogImage} />}
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={`${baseUrl}${currentPath}`} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {ogImage && <meta name="twitter:image" content={ogImage} />}
      
      {/* Additional SEO */}
      <meta name="robots" content="index, follow" />
      <meta name="googlebot" content="index, follow" />
    </Helmet>
  );
};

export default SEOHead;
